import { HttpClient, HttpResponse, HttpHeaders } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

import { environment } from '../../../../environments/environment';
import { APP_CONFIG } from '../../../configs/app-config.constants';
import { InterfaceAppConfig } from '../../../configs/app-interface.config';

@Injectable({
    providedIn: 'root',
})
export class SubmitgyanService {
    url: any;
    domainUrl = environment.gyanApiUrl;
    solrapiUrl = environment.solrApiUrl;

    private callSubmitGyanSubject = new Subject<boolean>();
    callSubmitGyanEvent$ = this.callSubmitGyanSubject.asObservable();

    constructor(
        private http: HttpClient,
        @Inject(APP_CONFIG)
        private config: InterfaceAppConfig,
    ) {}

    getKnowledgeStore(): Observable<any> {
        const url = this.domainUrl + this.config.apis.gyan.submitGyan.getKnowledgeStore;
        // console.log(url);
        return this.http.get(url);
    }

    initiateAdvancedQueries(gyanObj: any, gyanCookie: string): Observable<any> {
        const body = new FormData();
        body.append('concept', new Blob([JSON.stringify(gyanObj)], { type: 'application/json' }));

        const url = this.domainUrl + this.config.apis.gyan.submitGyan.initiateOldGyanSearch;
        //  console.log(url);
        return this.http.post(url, body);
    }

    getMDSforAdvancedQueries(topicId: any): Observable<any> {
        const url = this.domainUrl + this.config.apis.gyan.submitGyan.getMDS + '?topicId=' + topicId;
        //  console.log(url);
        return this.http.get(url);
    }

    getClickbackData(topicId: any, paragraphId: any, type: any): Observable<any> {
        const url = this.domainUrl + this.config.apis.gyan.submitGyan.clickback + '?topicId=' + topicId + '&paragraphId=' + paragraphId + '&type=' + type;
        //  console.log(url);
        return this.http.get(url);
    }

    getGyanStatus(gyanID: any): Observable<any> {
        const url = this.domainUrl + this.config.apis.gyan.gyanStatus.getGyanStatus + '?gyanId=' + gyanID;
        return this.http.get(url);
    }

    getIndexedRepositories(repositoryId: number): Observable<any> {
        const url = this.domainUrl + this.config.apis.gyan.submitGyan.indexedRepositories + '?repoId=' + repositoryId;
        return this.http.get(url);
    }

    getTags(recordId: string): Observable<any> {
        const url = this.domainUrl + this.config.apis.gyan.submitGyan.getTag + '?recordId=' + recordId;
        return this.http.get(url);
    }

    getRepoTags(siteName: string): Observable<any> {
        const url = this.domainUrl + this.config.apis.gyan.submitGyan.repoTags + '?siteName=' + siteName;
        return this.http.get(url);
    }

    //fl=country&indent=true&q.op=OR&q=country%3Ae*%20AND%20repoId%3Ac908e307-75ed-46fd-8689-97be17628931&rows=100&wt=csv

    getSolrData(repoId: string, tagName: string, searchValue: string): Observable<any> {
        const query = '?fl=' + tagName + '&indent=true&q.op=OR&q=' + tagName + ':"' + searchValue + '" AND repoId:' + repoId + '&rows=100&wt=json';

        const encodedQuery = encodeURI(query);
        //    console.log(encodedQuery);
        const url = this.solrapiUrl + this.config.apis.gyan.submitGyan.solrQuery + encodedQuery;
        //    console.log(url);

        return this.http.get(url);
    }

    getSolrDataGKS(repoName: string, tagName: string, searchValue: string): Observable<any> {
        const query = '?fl=' + tagName + '&indent=true&q.op=OR&q=' + tagName + ':"' + searchValue + '" AND repoName:' + repoName + '&rows=100&wt=json';
        const encodedQuery = encodeURI(query);
        //   console.log(encodedQuery);

        const url = this.solrapiUrl + this.config.apis.gyan.submitGyan.solrQuery + encodedQuery;
        //   console.log(url);

        return this.http.get(url);
    }

    getKnowledgeStoreTags(recordId: string): Observable<any> {
        const url = this.domainUrl + this.config.apis.gyan.submitGyan.getKnowledgeStoreTags + '?recordId=' + recordId;
        return this.http.get(url);
    }

    getTemplatesAndRecentLibrary(): Observable<any> {
        const url = this.domainUrl + this.config.apis.gyan.submitGyan.templateGyans;
        return this.http.get(url);
    }
    getSpecialsources(): Observable<any> {
        const url = this.domainUrl + this.config.apis.gyan.submitGyan.specialsources;
        return this.http.get(url);
    }

    emitSubmitGyanClickEvent(value: boolean) {
        console.log('emitSubmitGyanClickEvent.value', value);
        this.callSubmitGyanSubject.next(value);
    }

    getSearchDropDownData() {
        const url = this.domainUrl + this.config.apis.gyan.submitGyan.getSearchList;
        // console.log(url);
        return this.http.get(url);
    }

    getGyanTemplate(topicId: any) {
        console.log('the response from template API topicId', topicId);
        const url = this.domainUrl + this.config.apis.gyan.submitGyan.getGyanTemplate + '?topicId=' + topicId;
        return this.http.get(url);
    }
}
